import React from 'react';
import {
    Dialog,
    DialogActions,
    Button,
    DialogTitle,
    DialogContent,
    Divider,
    Typography,
    CircularProgress,
} from '@mui/material';

type DialogProps = {
    icon?: JSX.Element;
    title?: string;
    titleColor?:
        | 'inherit'
        | 'initial'
        | 'primary'
        | 'secondary'
        | 'textPrimary'
        | 'textSecondary'
        | 'error'
        | undefined;
    body: JSX.Element | string;
    okButtonText?: string;
    okButtonShow?: boolean;
    cancelButtonsShow?: boolean;
    cancelButtonText?: string;
    show: boolean;
    width: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
    closeDialog?: Function;
    handleOk?: Function;
    backgroundColor?: string;
    disableOk?: boolean;
    loading?: boolean;
    handleCopy?: Function;
    copyClipboardButtonText?: string;
    copyClipboardButtonShow?: boolean;
};
const setOkButtonVisiblity = (okButtonShow: boolean | undefined): boolean => (okButtonShow ? true : false);
const setCancelButtonVisiblity = (cancelButtonShow: boolean | undefined): boolean => (cancelButtonShow ? true : false);
const setcopyClipboardButtonVisiblity = (copyClipboardButtonShow: boolean | undefined): boolean => (copyClipboardButtonShow ? true : false);


export const ConfirmationPopUp: React.FC<DialogProps> = (props): JSX.Element => {
    const [disableOk, setDisableOk] = React.useState(true);
    const handleClose = (): void => { 
        if (props.closeDialog) props.closeDialog();
    };
    const handleOk = (): void => {
        if (props.handleOk) props.handleOk(true);
    };
    const handleCopy = (): void => {
        if (props.handleCopy) props.handleCopy();
        setDisableOk(false);
    }

    return (
        <Dialog
            disableEscapeKeyDown={true}
            open={props.show}
            onClose={(event, reason: string): void => {
                if (reason !== 'backdropClick' && props.closeDialog) {
                    props.closeDialog();
                }
            }}
            data-testid="confirmation-popup"
            maxWidth={props.width}
            fullWidth={true}
        >
            <DialogTitle id="dialog-title">
                <div style={{ textAlign: 'center' }}>{props.icon}</div>
                <div>
                    <Typography variant="h6" color={props.titleColor !== undefined ? props.titleColor : undefined}>
                        {props.title}
                    </Typography>
                </div>
            </DialogTitle>
            <DialogContent>{props.body}</DialogContent>
            <Divider />

            <DialogActions
                style={{ justifyContent: setCancelButtonVisiblity(props.cancelButtonsShow) || setcopyClipboardButtonVisiblity(props.copyClipboardButtonShow) ? 'space-between' : '' }}
            >
                 {setcopyClipboardButtonVisiblity(props.copyClipboardButtonShow) && (    
                    <Button 
                        autoFocus
                        color="secondary"
                        variant="outlined"
                        onClick={handleCopy}
                        data-testid="copy-action"
                    >
                        {props.copyClipboardButtonText}
                    </Button>
                )}
                {setCancelButtonVisiblity(props.cancelButtonsShow) && (
                    <Button
                        autoFocus
                        color="primary"
                        variant="outlined"
                        onClick={handleClose}
                        data-testid="cancel-action"
                    >
                        {props.cancelButtonText}
                    </Button>
                )}
                {setOkButtonVisiblity(props.okButtonShow) && (
                    <Button
                        autoFocus
                        color="secondary"
                        style={{ backgroundColor: props.backgroundColor }}
                        variant="contained"
                        onClick={handleOk}
                        data-testid="ok-action"
                        disabled={ props.copyClipboardButtonShow ? disableOk : props.disableOk}
                        startIcon={props.loading ? <CircularProgress size="1rem" style={{ color: 'white' }} /> : <></>}
                    >
                        {props.okButtonText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
